import React from 'react';
import {
  required,
  Edit,
  TextInput,
  SimpleForm,
  TranslatableInputs,
  ReferenceInput,
  SelectInput,
  BooleanInput
} from 'react-admin';

// own ui
import EditTitle from '../../ui/edit-title';
import CustomEditToolbar from '../../ui/custom-edit-toolbar';

const validateTheme = required('Selecione um tema!');
const validateName = [required('Digite o nome!')];

const SubThemeEdit = (props) => (
  <Edit {...props} title={ <EditTitle subtitle="Editar Sub Tema: " value="name" subvalue="pt_br" /> }>
    <SimpleForm redirect="/sub-theme" toolbar={<CustomEditToolbar />} >
      <TextInput source="id" label="Id" disabled />
      <ReferenceInput label="Tema" source="theme_id" fullWidth={true} reference="theme" validate={validateTheme}>
        <SelectInput optionText="name.pt_br" optionValue="id" />
      </ReferenceInput>
      <TranslatableInputs locales={['pt_br', 'en_us']} defaultLocale="pt_br">
        <TextInput source="name" label="Nome" fullWidth={true} validate={validateName} />
      </TranslatableInputs>
      <br/>
      <BooleanInput source="active" label="Ativo" />
    </SimpleForm>
  </Edit>
);

export default SubThemeEdit;
